import { createServerFn } from "@tanstack/react-start";

import type { McpServerPageContent } from "@/content/mcpServerPage";
import { contentSource } from "@/content/source";

/**
 * The MCP Server page's content, at prerender. No committed copy stands
 * behind it: a page with no document is not found.
 */
export const mcpServerPageCms = createServerFn({ method: "GET" }).handler(
  async (): Promise<McpServerPageContent | null> =>
    (await contentSource()).loadMcpServerPage()
);
